import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCountriesApi } from "../../constants/apiConstants";
import request from "../../utils/request";
export const getCountries = createAsyncThunk(
  "countriesReducer/countries",
  async ({ dispatch }) => {
    try {
      const res = await request({
        url: getCountriesApi.getCountries,
        method: "GET",
      });
      return res;
    } catch (error) {
      throw error;
    }
  }
);

const countriesSlice = createSlice({
  name: "getCountries",
  initialState: {
    countries: null,
    countriesLoading: false,
  },
  reducers: {
    countriesRes: (state, action) => {
      state.countries = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.countriesLoading = true;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.countriesLoading = false;
        state.countries = action.payload;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.countriesLoading = false;
      });
  },
});

export const { countriesRes } = countriesSlice.actions;
export default countriesSlice.reducer;
